import { useState, useMemo } from "react"
import { useYoungsWithPerfectAttendance } from "@/entities/user/useYoung"
import { QueryRender } from "@/components/helpers/QueryRender"
import { useCurrentSchoolYear } from "@/entities/schoolYear/useSchoolYear"
import { SchoolPeriodSelector } from "@/components/filters/SchoolPeriodSelector"
import { SchoolPeriod } from "@/entities/schoolYear/SchoolPeriod"
import { Link } from "react-router-dom"
import { UserCard } from "@/components/ui/UserCard"
import { YoungsFilterSearchBar } from "@/components/filters/YoungsFilterSearchBar"


export default function ParfaiteAssiduite() {
   const { data: currentSchoolYear, isLoading: isLoadingCurrentSchoolYear } = useCurrentSchoolYear()
   const [selectedPeriod, setSelectedPeriod] = useState<SchoolPeriod | null>(null)
   const [searchText, setSearchText] = useState("")
   const [selectedGroups, setSelectedGroups] = useState<string[]>([])
   
   const perfectAttendanceQuery = useYoungsWithPerfectAttendance({
      schoolyear_id: currentSchoolYear?.id || "",
      from: selectedPeriod?.start_date,
      to: selectedPeriod?.end_date,
   })

   const query = {
      isLoading: isLoadingCurrentSchoolYear || perfectAttendanceQuery.isLoading || selectedPeriod === null,
      isFetching: perfectAttendanceQuery.isFetching
   } as any

   const filteredYoungs = useMemo(() => {
      if (!perfectAttendanceQuery.data) return []
      
      return perfectAttendanceQuery.data.filter(young => {
         const matchesSearch = !searchText.trim() || 
            young.firstName?.toLowerCase().includes(searchText.toLowerCase()) ||
            young.lastName?.toLowerCase().includes(searchText.toLowerCase())

         const matchesGroups = selectedGroups.includes(young.group)

         return matchesSearch && matchesGroups
      })
   }, [perfectAttendanceQuery.data, searchText, selectedGroups])

   return (
      <>
         <div className="page-section">
            <h1 className="title">Jeunes avec assiduité parfaite</h1>
            
            <SchoolPeriodSelector setSelectedSchoolPeriod={setSelectedPeriod} />

            <YoungsFilterSearchBar
               searchText={searchText}
               setSearchText={setSearchText}
               selectedGroups={selectedGroups}
               setSelectedGroups={setSelectedGroups}
            />

            <QueryRender query={query} data={filteredYoungs}>
               {() => (
                  <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                     {filteredYoungs.map((young) => (
                        <Link key={young.id} to={`/admin/resume-du-jeune/${young.id}`}>
                           <UserCard user={young} key={`user-card-${young.id}`}></UserCard>
                        </Link>
                     ))}
                  </div>
               )}
            </QueryRender>
         </div>
      </>
   )
}
